module.exports = __webpack_public_path__ + "4b3afb84b2b71ef56df09997a350bd04.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/img/loader.gif
 ** module id = 2
 ** module chunks = 8
 **/